import { render, staticRenderFns } from "./ExtendedTables.vue?vue&type=template&id=29dab800"
import script from "./ExtendedTables.vue?vue&type=script&lang=js"
export * from "./ExtendedTables.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports